import { IShowable } from "../../interfaces/IShowable";
import { ScreenManager } from "../../managers/ScreenManager";
import { CardData, CardStackSocket, TextureData } from "../../types/types";
import { Card } from "../card/Card";
import { OptionsDataManager } from "../managers/OptionsDataManager";
import { AppSettings } from "../managers/AppSettings";
import { CardsManager } from "../managers/CardsManager";
import { AppTimings } from "../data/AppConstants";

export class CardStack
    extends Phaser.GameObjects.Container
    implements IShowable {
    public cardsContainer: Phaser.GameObjects.Container;
    public highlight: Phaser.GameObjects.Image;

    private isShowing: boolean = false;


    public Show(animated: boolean = true, onComplete: Function = undefined): void {
        // this.SetInteractiveChildren(true);

        // reset
        // this.scale = 0;
        this.alpha = 0;

        // if animate
        if (animated) {
            const genericShowDuration = OptionsDataManager.GetTiming(AppTimings.genericShowDuration);
            this.scene.tweens.add({
                targets: this,
                alpha: 1,
                // scale: 1,
                duration: genericShowDuration,
                ease: AppSettings.ease.genericShowHideEase,
                onComplete: () => onComplete?.(),
            })
        }
        else {
            this.alpha = 1;
            // this.scale = 1;
            onComplete?.();
        }
        this.isShowing = true;
    }

    public Hide(animated: boolean = true, onComplete: Function = undefined): void {
        // this.SetInteractiveChildren(false);

        // kill tweens
        // this.scene.tweens.killTweensOf();

        // ref

        // if animate
        if (animated) {
            const genericHideDuration = OptionsDataManager.GetTiming(AppTimings.genericHideDuration);
            this.scene.tweens.add({
                targets: this,
                alpha: 0,
                // scale: 0,
                duration: genericHideDuration,
                ease: AppSettings.ease.genericShowHideEase,
                onComplete: () => onComplete?.(),
            })
        }
        else {
            this.alpha = 0;
            // this.scale = 0;
            onComplete?.();
        }
        this.isShowing = false;
    }

    public IsShowing(): boolean {
        return this.isShowing;
    }

    public PoolCards(): void {
        if (this.HasCards()) {
            const pickedCards: Card[] = this.PickCards(this.GetLength());
            CardsManager.DropCards(pickedCards);
        }
    }

    public HasCards(): boolean {
        // return this.cards.length != 0;
        return this.cardsContainer.length != 0;
    }

    public GetLength(): number {
        // return this.cards.length;
        return this.cardsContainer.length;
    }

    public DropCard(card: Card, socketProps: CardStackSocket = undefined): void {
        this.cardsContainer.add(card);
        // this.cards.push(card);
        if (socketProps != undefined) {
            card.setPosition(socketProps.posX, socketProps.posY);
            card.setAngle(socketProps.angle);
        }
    }

    public DropCards(
        cards: Card[],
        socketsProps: CardStackSocket[] = undefined,
        reverseOrder: boolean = false
    ): void {
        while (cards.length) {
            if (reverseOrder) {
                const card: Card = cards.shift();
                this.cardsContainer.add(card);

                if (socketsProps != undefined) {
                    const socketProps: CardStackSocket = socketsProps.shift();
                    card.setPosition(socketProps.posX, socketProps.posY);
                    card.setAngle(socketProps.angle);
                }
            }
            else {
                const card: Card = cards.pop();
                this.cardsContainer.add(card);
                if (socketsProps != undefined) {
                    const socketProps: CardStackSocket = socketsProps.pop();
                    card.setPosition(socketProps.posX, socketProps.posY);
                    card.setAngle(socketProps.angle);
                }
            }
        }
    }

    public PickCard(card: Card): Card | null {
        if (this.HasCards()) {
            this.cardsContainer.removeAt(this.cardsContainer.length - 1);
            return card;
        }
        return null;
    }

    public GetLast(): Card | null {
        return this.cardsContainer.last as Card;
    }

    public GetFirst(): Card | null {
        return this.cardsContainer.first as Card;
    }

    public GetCards(): Card[] | null {
        return this.cardsContainer.list as Card[];
    }

    /**
     * Return contained Card[] as CardData[]
     */
    public GetCardDatas(): CardData[] {
        return this.GetCards().map((card: Card) => {
            return { rank: card.rank, suit: card.suit };
        })
            .reverse();
    }

    public GetCardByIndex(cardIndex: number): Card | null {
        return cardIndex > this.cardsContainer.length - 1 ? null : this.cardsContainer.getAt(cardIndex) as Card;
    }

    public PickLast(): Card | null {
        const card: Card = this.cardsContainer.last as Card; // Card | null
        this.cardsContainer.removeAt(this.cardsContainer.length - 1);
        return card;
    }

    public PickCards(count: number): Card[] | null {
        if (this.HasCards()) {
            const returnCards: Card[] = [];
            const pickCardsCount: number = Math.min(count, this.GetLength());
            for (let i: number = 0; i < pickCardsCount; i++) {
                const lastCardIndex: number = this.cardsContainer.length - 1;
                const card: Card = this.cardsContainer.getAt(lastCardIndex) as Card;
                returnCards.push(card);
                this.cardsContainer.removeAt(lastCardIndex);
            }
            return returnCards;
        }
        return null;
    }

    constructor(
        scene: Phaser.Scene,
        x: number = 0,
        y: number = 0,
        // highlightTextureData: TextureData = null,
    ) {
        super(scene, x, y);

        // create cards container
        this.cardsContainer = this.scene.add.container();
        this.add(this.cardsContainer);

        // if (highlightTextureData != null) {
        //     // create highlight/stroke/selection ring (for smart hints)
        //     this.highlight = this.scene.add.image(0, 0, highlightTextureData.texture, highlightTextureData.frame);
        //     this.highlight.setScale(ScreenManager.svScaleFactor);
        //     this.highlight.alpha = 0;
        //     this.add(this.highlight);
        // }
    }

    public NextSocketsIndex(): void
    {
        // override in subclass (if applicable)
    }
}